import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { JSX } from "react";

interface IAlertBoxProps {
  title: string;
  content: JSX.Element;
  isOpen: boolean;
  onClose(): void;
  height?: string;
  width?: string;
  fullWidth?: boolean;
  fullScreen?: boolean;
}

export default function AlertBox(props: IAlertBoxProps) {
  return (
    <React.Fragment>
      <Dialog
        fullWidth={props.fullWidth ?? true}
        fullScreen={props.fullScreen ?? false}
        open={props.isOpen}
        onClose={props.onClose}
        aria-labelledby="responsive-dialog-title"
        sx={{ height: props.height ?? "100%", width: props.width ?? "100%" }}
      >
        <DialogTitle id="responsive-dialog-title">{props.title}</DialogTitle>
        <DialogContent>{props.content}</DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
